import { render } from "./commandeListe.vue?vue&type=template&id=0c4c57f8&scoped=true"
import script from "./commandeListe.vue?vue&type=script&lang=js"
export * from "./commandeListe.vue?vue&type=script&lang=js"

import "./commandeListe.vue?vue&type=style&index=0&id=0c4c57f8&lang=scss&scoped=true"

import exportComponent from "/usr/src/test-oho-sales/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4c57f8"]])

export default __exports__